import React from 'react'

import { DefectNoticeListItem } from '../../../common/validations/defectNotice'
import { useAPIGetDefectNoticesSuspense } from '../../api/apiHooks/useAPIGetDefectNotices'
import { useCurrentContract } from '../../hooks/useCurrentContract/useCurrentContract'

type Data = {
  defectNotices: DefectNoticeListItem[]
}

export const SidebarDataLoader = ({
  children,
}: {
  children: (data: Data) => React.ReactNode
}) => {
  const { currentContractId } = useCurrentContract()
  const { data: defectNotices } =
    useAPIGetDefectNoticesSuspense(currentContractId)

  return children({
    defectNotices,
  })
}
